'use strict';

(function () {
  angular.module('zp').controller('mixUserController', mixUserController);

  /**@ngInject */
  function mixUserController($window, $q, $rootScope, $state, vendorsService, mixesService, LoaderService, mixesGridStyle, authService, SlugerService) {
    var vm = this;

    vm.mix = [];
    vm.mixes = [];
    vm.user = null;
    vm.emptyMix = false;

    vm.openVendor = openVendor;
    vm.removeFromFavourites = removeFromFavourites;
    vm.openMix = openMix;

    var mGridStyle = $window.innerWidth > 1200 ? mixesGridStyle.xl : mixesGridStyle.l;

    (function () {
      LoaderService.start();
      loadUserMix().then(loadAllMixes).then(LoaderService.stop);
    })();

    function loadUserMix() {
      if (!$rootScope.currentUser) {
        return $q.when(function () {
          vm.emptyMix = true;
          return true;
        }());
      }
      vm.user = $rootScope.currentUser;
      var promises = [];
      var index = 0;
      for (var i in vm.user.favourites) {
        if (!vm.user.favourites.hasOwnProperty(i)) {
          continue;
        }
        var gridStyleIndex = index;
        if (index >= mGridStyle.length) {
          gridStyleIndex = index % mGridStyle.length;
        }
        var c = {
          currentIndex: 0,
          name: i,
          items: [],
          style: mGridStyle[gridStyleIndex]
        };
        promises.push(loadCategoryItems(c, vm.user.favourites[i]));
        index++;
      }
      return $q.all(promises).then(function (response) {
        vm.mix = [];
        for (var i = 0; i < response.length; i++) {
          if (response[i].items && response[i].items.length) {
            vm.mix.push(response[i]);
          }
        }
        vm.emptyMix = vm.mix.length === 0;
      });
    }

    function openMix(mix) {
      $state.go('nav.mix-item', { alias: mix.alias });
    }

    function loadCategoryItems(category, ids) {
      var promises = [];
      for (var i = 0; i < ids.length; i++) {
        promises.push(vendorsService.getOne(ids[i], category.name));
      }
      return $q.all(promises).then(function (response) {
        category.items = response;
        return category;
      });
    }

    function openVendor(vendor, event) {
      if (event.originalEvent.target.className !== 'glyphicon glyphicon-chevron-right' && event.originalEvent.target.className !== 'glyphicon glyphicon-chevron-left') {
        var url = $state.href('nav.vendor-slug', { vendor: vendor.category, slugCity: SlugerService.generateSlug(vendor.city), slugName: SlugerService.generateSlug(vendor.name) });
        window.open(url, '_blank');
      }
    }

    function loadAllMixes() {
      return mixesService.getAll().then(function (response) {
        vm.mixes = response;
      });
    }

    function removeFromFavourites(vendor) {
      var user = $rootScope.currentUser;
      if (!user.favourites[vendor.category]) {
        return false;
      }
      var indexOfVendor = user.favourites[vendor.category].indexOf(vendor.id);
      if (indexOfVendor === -1) {
        return false;
      }
      LoaderService.start();
      user.favourites[vendor.category].splice(indexOfVendor, 1);
      return authService.update(user).then(loadUserMix).then(LoaderService.stop);
    }
  }
})();